<script setup>
import { useI18n } from "vue-i18n";
import { ref, watch } from 'vue'

const { t } = useI18n();
const { locale } = useI18n();
let location = ref(locale.value);
let description = t('field.connected')

watch(locale, () => {
    location = locale.value;
}); 
</script>
<template>
    <div class="inner-wrapper">
        <div class="box">
            <div class="row h-100">
                <div class="col-md-6 col-sm-12 gdpr-padding-right">
                    <div class="functionalities-gdpr-video-wrapper functionalitites-gdpr">
                        <div class="video-text">
                            <span v-html="description"></span>
                        </div>
                        <div class="video-inner-wrapper">
                            <video 
                                class="functionalities-gdpr-video-js vjs-poster"
                                id="myVideo"
                                preload="auto"
                                autoplay muted loop>
                                <source src="/assets/functionalities/Tap_Tablet_Negre.mp4" type="video/webm">
                            </video>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-sm-12 gdpr-padding-left">
                    <div class="block-wrapper">
                        <div class="block-inner-wrapper">
                            <div class="block-content h-100">
                                <div class="row h-100">
                                    <div class="col-12 left-col">
                                        <div class="left-wrapper">
                                            <div class="left-inner-wrapper">
                                                <div class="title-wrapper">
                                                    <span class="primary-text">{{ $t('field.car') }}</span>
                                                    {{ $t('field.rgdp') }}
                                                </div>
                                                <div class="functionalities-block-subtitle">
                                                    {{ $t('functionalities.gdpr_title') }}
                                                </div>
                                                <div class="funcionalities-cases">
                                                    <div class="case">
                                                        <div class="subtitle">
                                                            {{ $t('functionalities.gdpr_subtitle') }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="functionalitites-plus">
                                                <router-link :to="`/${location}/gdpr`" @click="closeMenu">
                                                    <font-awesome-icon icon="fa-solid fa-plus" />
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    .inner-wrapper {
        padding: 25px 0;
    }
    .left-col {
        padding-left: 10px;
        padding-top: 40px;
        padding-right: 0px;
        .left-wrapper {
            padding-left: 30px;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
    }
    .box {
        height: 406px;
        .functionalities-gdpr-video-wrapper {
            background-color: black;
            height: 100%;
            max-height: 427px;
            border-radius: 20px;
            position: relative;
            video {
                width: 100%;
                height: 100%;
                border-radius: 20px;
                object-position: center center;
                object-fit: cover;
            }
            .video-text {
                position: absolute;
                color: white;
                font-size: 50px;
                letter-spacing: -2.5px;
                line-height: 50px;
                width: 100%;
                text-align: center;
                font-family: 'CircularStd-Bold';
                top: 40%
            }
            .video-inner-wrapper {
                height: 100%;
            }
        }
        .functionalities-image-wrapper {
            text-align: right;
            img {
                max-height: 385px;
            }
        }
    }
    .block-wrapper {
        height: 100%;
        background: #EDEFF2 0% 0% no-repeat padding-box;
        border-radius: 20px;
    }
    .block-inner-wrapper {
        height: 100%;
        padding: 10px 30px 20px;
        .row {
            margin: 0;
            padding: 0;
        }
        .title-wrapper {
            text-transform: lowercase;
            font-family: 'CircularStd-Bold';
            font-size: 30px;
            letter-spacing: -1.5px;
            text-transform: lowercase;
            font-family: 'CircularStd-Bold';
            padding-bottom: 18px;
        }
        .functionalities-block-subtitle {
            font-size: 16px;
            letter-spacing: -0.4px;
            font-weight: bold;
            padding-bottom: 18px;
        }
        .funcionalities-cases {
            font-size: 16px;
            .title {
                font-family: 'CircularStd-Bold';
                font-size: 16px;
            }
        }
    }
    .video-wrapper {
        height: 427px;
    }
    .functionalitites-plus {
        font-size: 25px;
        text-align: right;
        padding-top: 10px;
        a {
            color: #0047ba;
            display: inline-block;
            transition: transform .7s ease-in-out;
            &:hover {
                transform: rotate(90deg);
            }
        }
    }
    .gdpr-padding-right {
        padding-right: 25px;
    }
    .gdpr-padding-left {
        padding-left: 25px;
    }
    @media (max-width: 400px) {
        .gdpr-padding-left {
            padding-left: 15px;
            padding-top: 50px;
        }
        .gdpr-padding-right {
            padding-right: 15px;
        }
        .functionalities-gdpr-video-wrapper {
            background-image: url("/assets/mobile/paperless2.webp");
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            min-height: 390px;
            video {
                display: none;
            }
        }
        .box .functionalities-gdpr-video-wrapper video {
            display: none;
        }
    }
    @media (max-width: 600px) {
        .box {
            .functionalities-gdpr-video-wrapper.functionalitites-gdpr {
                background-image: url("/assets/mobile/Conectados2.webp");
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
                min-height: 390px;
                video {
                    display: none;
                }
            }
        }
        .gdpr-padding-right {
            padding-bottom: 50px;
        }
    }
    @media (max-width: 1000px) {
        .container-functionality-wrapper {
            padding: 60px 50px;
            .functionalitites-blocks  {
                padding: 0;
            }
        }
        .left-col {
            padding-left: 0px;
            .left-wrapper {
                padding-left: 0px;
            }
        }
        .box {
            height: auto;
            .gdpr-padding-right {
                padding-right: 15px;
            }
            .gdpr-padding-left {
                padding-left: 15px;
            }
            .functionalities-gdpr-video-wrapper {
                video {
                    height: 417px;
                }
            }
        }
    }
</style>